module.exports = __webpack_public_path__ + "img/manage-news-active.d1913fbc.svg";